
import { useQuery } from "@tanstack/react-query";
import { fetchSubscriptionPlans } from "@/services/subscription/planService";
import { Plan } from "@/types/subscription";
import { useState, useEffect } from "react";

export const useFetchSubscriptionPlans = () => {
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  
  const { 
    data, 
    isLoading, 
    error,
    refetch,
    isError
  } = useQuery({
    queryKey: ['subscriptionPlans'],
    queryFn: fetchSubscriptionPlans,
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: 3,
    refetchOnWindowFocus: false,
  });

  // Ensure plans is always an array even if data is undefined
  const plans: Plan[] = data || [];

  // Mettre à jour le message d'erreur quand error change
  useEffect(() => {
    if (isError) {
      console.error("Error in useFetchSubscriptionPlans:", error);
      setErrorMessage("Impossible de charger les plans d'abonnement");
    } else {
      setErrorMessage(null);
    }
  }, [isError, error]);

  console.log("useFetchSubscriptionPlans - plans:", plans);
  console.log("useFetchSubscriptionPlans - isLoading:", isLoading);
  console.log("useFetchSubscriptionPlans - error:", error);
  console.log("useFetchSubscriptionPlans - errorMessage:", errorMessage);

  return { 
    plans, 
    isLoading, 
    isError,
    error: errorMessage,
    refetch
  };
};
